
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IFacilityProfile } from './types';
import apiCall from 'utils/api';

export const fetchFacilityProfile = createAsyncThunk(
  'facilityProfile/fetchFacilityProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ data: IFacilityProfile }>('get', '/api/facility/profile/');
      return response.data.data;
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch facility profile');
    }
  }
);
